import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { isValidPhoneNumber } from "react-phone-number-input";

import { ReactComponent as RemoveIcon } from "../../../assets/cross.svg";
import { ReactComponent as GroupIcon } from "../../../assets/Group.svg";
import {
  h4Medium,
  h5Medium,
  h6Medium,
  h6Regular,
  h7Regular,
  pointer,
} from "../../../shared/constants";

const useStyles = makeStyles({
  container: {
    width: 340,
    height: "auto",
    background: "#FFFFFF",
    boxShadow: "0px 16px 32px rgba(29, 38, 102, 0.08)",
    borderRadius: 32,
    padding: 40,
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    ...h4Medium,
    marginBottom: 16,
  },
});

const VerifyNumber = ({
  phoneNumber = "000000000",
  onChangeNumber,
  handleClose,
  onVerify,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [digits, setDigits] = useState({
    a: "",
    b: "",
    c: "",
    d: "",
  });

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (
      digits.a &&
      digits.b &&
      digits.c &&
      digits.d &&
      isValidPhoneNumber(phoneNumber)
    ) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [digits]);

  const handleChange = (e) => {
    const { value, name } = e.target;

    setDigits({ ...digits, [name]: value });
  };

  return (
    <div className={classes.container}>
      <div className={classes.header} style={{ direction: t("css.side") }}>
        <span>{t("verifyNumber.verifyYourNumber")}</span>
        <span
          style={{ ...pointer }}
          onClick={() => {
            handleClose();
          }}
        >
          <RemoveIcon style={{ height: 24, width: 24 }} />
        </span>
      </div>

      <div style={{ ...h6Regular, marginBottom: 16 }}>
        {t("verifyNumber.textMessage")}
        <span> {phoneNumber} </span>
      </div>

      <div
        style={{
          ...h6Medium,
          color: "#80BB34",
          marginBottom: 30,
          direction: t("css.side"),
          ...pointer,
        }}
        onClick={() => {
          onChangeNumber(true);
        }}
      >
        {t("verifyNumber.changeNumber")}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: 44,
          direction: t("css.side"),
        }}
      >
        <span style={{ ...h7Regular, color: "#15222F", opacity: 0.4 }}>
          {t("verifyNumber.smsCode")}
        </span>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <input
            maxLength="1"
            name="a"
            onChange={handleChange}
            style={{
              border: "none",
              borderBottom: "1px solid lightgrey",
              background: "none",
              outline: "none",
              maxWidth: 40,
              padding: 10,
              ...h5Medium,
              textAlign: "center",
            }}
          />
          <input
            maxLength="1"
            name="b"
            onChange={handleChange}
            style={{
              border: "none",
              borderBottom: "1px solid lightgrey",
              background: "none",
              outline: "none",
              maxWidth: 40,
              padding: 10,
              ...h5Medium,
              textAlign: "center",
            }}
          />
          <input
            maxLength="1"
            name="c"
            onChange={handleChange}
            style={{
              border: "none",
              borderBottom: "1px solid lightgrey",
              background: "none",
              outline: "none",
              maxWidth: 40,
              padding: 10,
              ...h5Medium,
              textAlign: "center",
            }}
          />
          <input
            maxLength="1"
            name="d"
            onChange={handleChange}
            style={{
              border: "none",
              borderBottom: "1px solid lightgrey",
              background: "none",
              outline: "none",
              maxWidth: 40,
              padding: 10,
              ...h5Medium,
              textAlign: "center",
            }}
          />
        </div>
      </div>
      <button
        style={{
          width: "100%",
          height: "56px",
          background: !isValid ? "lightGrey" : "#80BB34",
          color: "#ffffff",
          borderRadius: 16,
          border: "none",
          ...pointer,
          ...h5Medium,
          marginBottom: 32,
        }}
        onClick={() => {
          if (isValid) {
            onVerify(true);
          }
        }}
      >
        {t("verifyNumber.verify")}
      </button>

      <div
        style={{
          textAlign: "center",
          ...h6Medium,
          color: "#80BB34",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <GroupIcon style={{ marginRight: 8 }} />
        <span style={{ ...pointer }}>{t("verifyNumber.resendCode")}</span>
      </div>
    </div>
  );
};

export default VerifyNumber;
